import React from 'react'

import classes from './TableHeader.module.scss'

export const TableHeader: React.FC = props => {
  return <div className={classes.header} {...props} />
}
